import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data;
  if (d?.error?.message) return d.error.message;
  const detail = d?.detail;
  if (detail == null) return e?.message || "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return detail.msg || String(detail);
}

export const errCode = (e) => e?.response?.data?.error?.code;

export const CATEGORY_META = {
  local_no_provider_api_fee: { label: "Lokal – keine API-Gebühr", cls: "bg-cyan-500/12 text-cyan-300 border-cyan-500/30" },
  free_tier_limited: { label: "Free-Tier (limitiert)", cls: "bg-emerald-500/12 text-emerald-300 border-emerald-500/30" },
  free_model_limited: { label: "Nur Gratis-Modelle", cls: "bg-emerald-500/12 text-emerald-300 border-emerald-500/30" },
  trial_or_credit: { label: "Testguthaben", cls: "bg-amber-500/12 text-amber-300 border-amber-500/30" },
  paid: { label: "Kostenpflichtig", cls: "bg-red-500/12 text-red-300 border-red-500/40" },
  unknown: { label: "Kosten unklar", cls: "bg-slate-500/12 text-slate-300 border-slate-500/30" },
};

export const TYPE_LABEL = { inference_provider: "Inference-Provider", gateway: "Gateway", local_runtime: "Lokale Laufzeit" };
export const FREE_STATUSES = ["local_no_provider_api_fee", "free_tier_limited", "free_model_limited"];
export const isPaidProvider = (p) => !!p && !FREE_STATUSES.includes(p.cost_status);
export const isPaidRoute = (p, model) => !!p && (isPaidProvider(p) || (p.cost_status === "free_model_limited" && !!model && !model.endsWith(":free")));

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" }) : "–");
